(() => {
  'use strict';
  if (document.documentElement.hasAttribute('data-auriani-commerce-events')) return;
  document.documentElement.setAttribute('data-auriani-commerce-events', '');
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.defaultPrevented) return;
    const link = event.target.closest?.('a[data-analytics-product-id]');
    if (!link) return;
    try {
      const target = new URL(link.href, location.origin);
      if (target.origin !== location.origin || !target.pathname.includes('/products/')) return;
      const client = window.AurianiAnalytics;
      if (!client) return;
      Promise.resolve(client.track('select_item', {
        product_id: link.dataset.analyticsProductId,
        variant_id: link.dataset.analyticsVariantId,
        source: link.dataset.analyticsSource
      }, client.newOccurrence())).catch(() => {});
    } catch (_) { /* Analytics must not interfere with native navigation. */ }
  });
})();
